import React from "react";
import { Card, CardContent } from "../ui/card";

export function HelpModule({ t }) {
  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
      
      {/* Login & Benutzerrollen */}
      <Card className="panel lightCard" style={{marginTop: 8}}>
        <CardContent>
          <div className="panel-title darktxt">{t('help_login_title')}</div>
          <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5'}}>
            {t('help_login_text')}
          </div>
        </CardContent>
      </Card>

      {/* LPR Analyse */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt">{t('help_analysis_title')}</div>
          <div className="field">
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5', marginBottom: 8}}>
              {t('help_analysis_sightings')}
            </div>
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5', marginBottom: 8}}>
              {t('help_analysis_delta')}
            </div>
            
            {/* New Sightings Chart Help Section */}
            <div style={{marginTop: 12, padding: '12px', backgroundColor: '#f0f9ff', borderRadius: '6px', border: '1px solid #0ea5e9'}}>
              <div className="panel-title darktxt" style={{fontSize: '14px', marginBottom: 4}}>
                {t('help_sightings_chart_title')}
              </div>
              <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5'}}>
                {t('help_sightings_chart_text')}
              </div>
            </div>
          </div>
          
          {/* Farbcode Legende */}
          <div className="field" style={{marginTop: 12}}>
            <div className="small" style={{marginBottom: 8}}>
              <strong>Farblegende Delta-Analyse:</strong>
            </div>
            <div style={{display: 'flex', gap: '12px', flexWrap: 'wrap'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                <div style={{width: '12px', height: '12px', backgroundColor: '#10b981', borderRadius: '2px'}}></div>
                <span className="small">Grün: Unter Schwelle</span>
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                <div style={{width: '12px', height: '12px', backgroundColor: '#f59e0b', borderRadius: '2px'}}></div>
                <span className="small">Gelb: Nahe Schwelle</span>
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                <div style={{width: '12px', height: '12px', backgroundColor: '#ef4444', borderRadius: '2px'}}></div>
                <span className="small">Rot: Deutlich drüber</span>
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                <span style={{fontSize: '14px'}}>🔴</span>
                <span className="small">{t('vip_plates')}</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Status Dashboard */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt">{t('help_status_title')}</div>
          <div className="field">
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5', marginBottom: 8}}>
              {t('help_status_system')}
            </div>
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5'}}>
              {t('help_status_cameras')}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Audit Dashboard */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt">{t('help_audit_title')}</div>
          <div className="field">
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5', marginBottom: 8}}>
              {t('help_audit_overview')}
            </div>
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5', marginBottom: 8}}>
              {t('help_audit_timerange')}
            </div>
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5', marginBottom: 8}}>
              {t('help_audit_table')}
            </div>
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5', marginBottom: 8}}>
              {t('help_audit_columns')}
            </div>
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5'}}>
              {t('help_audit_actions')}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Einstellungen */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt">{t('help_settings_title')}</div>
          <div className="field">
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5', marginBottom: 8}}>
              {t('help_settings_user')}
            </div>
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5', marginBottom: 8}}>
              {t('help_settings_positive')}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* VIP Kennzeichen */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt" style={{color: '#dc2626'}}>
            {t('help_vip_title')}
          </div>
          <div className="field">
            <div className="small" style={{marginBottom: 8}}>
              <strong>{t('help_vip_text')}</strong>
            </div>
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_vip_types_label')}</strong><br/>
              {t('help_vip_types')}
            </div>
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>Funktionen:</strong><br/>
              {t('help_vip_functions')}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Admin-Funktionen */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt">{t('help_admin_title')}</div>
          <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5'}}>
            {t('help_admin_text')}
          </div>
        </CardContent>
      </Card>

      {/* AI Analytics */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt" style={{color: '#6366f1'}}>
            {t('help_ai_analytics_title')}
          </div>
          <div className="field">
            <div className="small" style={{marginBottom: 8}}>
              <strong>{t('help_ai_analytics_intro')}</strong>
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_ai_analytics_setup')}</strong><br/>
              {t('help_ai_analytics_setup_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_ai_analytics_usage')}</strong><br/>
              {t('help_ai_analytics_usage_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_ai_analytics_helix')}</strong><br/>
              {t('help_ai_analytics_helix_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4'}}>
              <strong>{t('help_ai_analytics_history')}</strong><br/>
              {t('help_ai_analytics_history_desc')}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Kassensystem */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt" style={{color: '#059669'}}>
            {t('help_kasse_title')}
          </div>
          <div className="field">
            <div className="small" style={{marginBottom: 8}}>
              <strong>{t('help_kasse_intro')}</strong>
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_kasse_add_items')}</strong><br/>
              {t('help_kasse_add_items_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_kasse_transactions')}</strong><br/>
              {t('help_kasse_transactions_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4'}}>
              <strong>{t('help_kasse_settings')}</strong><br/>
              {t('help_kasse_settings_desc')}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Versandlabel System */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt" style={{color: '#8B4513'}}>
            {t('help_shipping_title')}
          </div>
          <div className="field">
            <div className="small" style={{marginBottom: 8}}>
              <strong>{t('help_shipping_intro')}</strong>
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_shipping_label')}</strong><br/>
              {t('help_shipping_label_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_shipping_workflow')}</strong><br/>
              {t('help_shipping_workflow_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_shipping_verkada')}</strong><br/>
              {t('help_shipping_verkada_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_shipping_settings')}</strong><br/>
              {t('help_shipping_settings_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_shipping_features')}</strong><br/>
              {t('help_shipping_features_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4'}}>
              <strong>{t('help_shipping_history')}</strong><br/>
              {t('help_shipping_history_desc')}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Automation */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt" style={{color: '#f59e0b'}}>
            ⚡ {t('help_automation_title')}
          </div>
          <div className="field">
            <div className="small" style={{marginBottom: 8}}>
              <strong>{t('help_automation_intro')}</strong>
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_automation_setup')}</strong><br/>
              {t('help_automation_setup_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_automation_control')}</strong><br/>
              {t('help_automation_control_desc')}
            </div>
            
            <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.4', marginBottom: 8}}>
              <strong>{t('help_automation_status')}</strong><br/>
              {t('help_automation_status_desc')}
            </div>
            
            {/* Status Farblegende */}
            <div style={{marginTop: 8, padding: '10px', backgroundColor: '#fffbeb', borderRadius: '6px', border: '1px solid #f59e0b'}}>
              <div className="small" style={{marginBottom: 6}}>
                <strong>{t('help_automation_colors')}</strong>
              </div>
              <div style={{display: 'flex', gap: '12px', flexWrap: 'wrap'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                  <div style={{width: '12px', height: '12px', backgroundColor: '#10b981', borderRadius: '50%'}}></div>
                  <span className="small">{t('help_automation_color_on')}</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                  <div style={{width: '12px', height: '12px', backgroundColor: '#ef4444', borderRadius: '50%'}}></div>
                  <span className="small">{t('help_automation_color_off')}</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                  <div style={{width: '12px', height: '12px', backgroundColor: '#6b7280', borderRadius: '50%'}}></div>
                  <span className="small">{t('help_automation_color_offline')}</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                  <div style={{width: '12px', height: '12px', backgroundColor: '#fbbf24', borderRadius: '50%'}}></div>
                  <span className="small">{t('help_automation_color_loading')}</span>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Tipps & Tricks */}
      <Card className="panel lightCard">
        <CardContent>
          <div className="panel-title darktxt">{t('help_tips_title')}</div>
          <div className="small" style={{whiteSpace: 'pre-line', lineHeight: '1.5'}}>
            {t('help_tips_text')}
          </div>
          
          {/* Wichtiger Hinweis */}
          <div className="field" style={{marginTop: 12}}>
            <div style={{
              backgroundColor: 'rgba(59,130,246,0.1)', 
              padding: '8px 12px', 
              borderRadius: '4px', 
              border: '1px solid rgba(59,130,246,0.2)'
            }}>
              <div className="small">
                <strong>{t('help_workflow_title')}</strong><br/>
                {t('help_workflow_steps')}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

    </div>
  );
}
